function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M27,0C12.0883179,0,0,12.0883179,0,27s12.0883179,27,27,27s27-12.0883179,27-27S41.9116821,0,27,0z M36.9302979,21.7335815c0.0158081,0.2296753,0.0158081,0.4594116,0.0158081,0.6890869 C36.946106,29.4281006,31.7907104,37.5,22.368042,37.5c-2.9029541,0-5.5996094-0.8696289-7.868042-2.3789062 c0.4124756,0.0491943,0.80896,0.0656128,1.2373047,0.0656128c2.3952637,0,4.6002808-0.836731,6.361084-2.2639771 c-2.2525635-0.0493164-4.1402588-1.5750122-4.7906494-3.6750488c0.3172607,0.0491333,0.6345215,0.0820312,0.9676514,0.0820312 c0.460022,0,0.920105-0.0657349,1.3483887-0.180542c-2.3477173-0.4921875-4.1085815-2.625-4.1085815-5.2007446v-0.0656128 c0.6820679,0.3937378,1.4752808,0.6398315,2.315979,0.6726074c-1.380127-0.9515381-2.2842407-2.5757446-2.2842407-4.413269 c0-0.984375,0.2537842-1.8867188,0.697937-2.6741943c2.5222168,3.2156372,6.3135376,5.3155518,10.5646973,5.5452881 c-0.0792847-0.3937378-0.1268921-0.803833-0.1268921-1.2139893c0-2.9203491,2.2843018-5.2992554,5.1238403-5.2992554 c1.4751587,0,2.8076782,0.6398315,3.7435913,1.6734619c1.15802-0.2296753,2.2683716-0.6726685,3.2518921-1.2797241 c-0.3806763,1.2305298-1.1896973,2.2640991-2.2525024,2.9202881c1.0311279-0.1147461,2.0305176-0.4101562,2.9505005-0.8202515 C38.802124,20.0437012,37.9296265,20.9788208,36.9302979,21.7335815z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "54px",
    height: "54px",
    viewBox: "0 0 54 54",
    style: {
      "enableBackground": "new 0 0 54 54"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/twitter.88a3207e.svg";
export { SvgComponent as ReactComponent };